import { render } from "./DetailExternal.vue?vue&type=template&id=81462f1e&scoped=true"
import script from "./DetailExternal.vue?vue&type=script&lang=js"
export * from "./DetailExternal.vue?vue&type=script&lang=js"

import "./DetailExternal.vue?vue&type=style&index=0&id=81462f1e&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81462f1e"]])

export default __exports__